import { Loader } from './styled';

export default function LoaderMini(): JSX.Element {
  return <Loader />;
}
